export default "__VITE_ASSET__aGX0l4UT__"